import { useEffect, useState } from "react";

import {
  AGENCY_CHROME_EXTENSION_ID,
  CHROME_EXTENSION_ID,
} from "common/constants";
import {
  getChromeExtensionUrl,
  getWhitelabelCustomization,
} from "common/helpers/utils";
import useChromeExtension from "common/hooks/useChromeExtension";

//this id is used for the extension url
let extensionId = CHROME_EXTENSION_ID;
if (getWhitelabelCustomization()) {
  extensionId =
    getWhitelabelCustomization().extension_id || AGENCY_CHROME_EXTENSION_ID;
}

//this is the id used for extension communication, id is undefined for client dashboards
const communicationExtensionId = getWhitelabelCustomization()
  ? undefined
  : CHROME_EXTENSION_ID;

const isExtensionLoginVisible =
  !getWhitelabelCustomization() ||
  getWhitelabelCustomization().use_chrome_extension;

const isExtensionSupported = navigator.userAgent.includes("Chrome");

export default function useExtensionLogin() {
  const [extensionName, setExtensionName] = useState(
    getWhitelabelCustomization() ? "Profile Connector" : "Aimfox Chrome",
  );
  const [extensionState, setExtensionState] = useState<
    "init" | "available" | "unavailable"
  >("init");

  const { pingExtension, getExtensionCookies } = useChromeExtension();

  function getLoginCookies() {
    return getExtensionCookies(communicationExtensionId);
  }

  function checkExtension() {
    if (isExtensionSupported) {
      pingExtension(communicationExtensionId)
        .then((response) => {
          if (response.status === "ok") {
            setExtensionState("available");

            if (getWhitelabelCustomization()) {
              setExtensionName(response.response.name);
            }
          } else {
            setExtensionState("unavailable");
          }
        })
        .catch(() => {
          setExtensionState("unavailable");
        });
    }
  }

  useEffect(() => {
    checkExtension();

    // Re-check when user focuses the window (common when extension is installed/uninstalled)
    window.addEventListener("focus", checkExtension);

    return () => {
      window.removeEventListener("focus", checkExtension);
    };
  }, []);

  return {
    extensionName,
    extensionUrl: getChromeExtensionUrl(extensionId),
    isExtensionSupported,
    extensionState,
    isExtensionLoginVisible,
    getLoginCookies,
  };
}
